import {money} from '@platform/client';
import {useCopy} from './config';

// One accepted-stake face in purchase, live and result headers.
export function CardAmountBadge({minor,currency,className}:{minor:number;currency:string;className:string}){
 const t=useCopy(),amount=money(minor,currency),description=t('card.investedShort')+' '+amount;
 return <span className={'card-amount-badge '+className} aria-label={description} title={description}><strong>{amount}</strong></span>;
}
